import { render, staticRenderFns } from "./HistoryTimeline.vue?vue&type=template&id=284d4e03&scoped=true"
import script from "./HistoryTimeline.vue?vue&type=script&lang=js"
export * from "./HistoryTimeline.vue?vue&type=script&lang=js"
import style0 from "./HistoryTimeline.vue?vue&type=style&index=0&id=284d4e03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284d4e03",
  null
  
)

export default component.exports